import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    notifications: [], 
};

const notificationsSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        setNotifications: (state, action) => {
            state.notifications = action.payload;
        },

    },
});

export const { setNotifications } = notificationsSlice.actions;
export default notificationsSlice.reducer;
